import { useFormik } from "formik";
import { SugerenciaForm } from "./form";
import { sugerenciaEmpaqueInitialValues } from "../constants";
import { sugerenciaEmpaqueValidationSchema } from "../validation";
import { useSugerencia } from "../hooks/useSugerencia";
import Swal from "sweetalert2";
import { useEffect } from "react";
import axios from "axios";

export const EditarSugerenciaEmpaque = ({
  onRefresh,
  sugerencia,
  onCancel,
}) => {
  const { updateSugerencia, isSaving } = useSugerencia();
  const onSubmit = async (values) => {
    try {
      await updateSugerencia(sugerencia.id, values);
      Swal.fire({
        icon: "success",
        title: "Sugerencia actualizada",
        timer: 1500,
      });
      resetForm();
      onRefresh();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Algo salió mal!",
            text: `${error.response.data.msg} - Si el error persiste favor de comunicar al equipo de desarrollo`,
          });
          return;
        }
      }

      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: `Favor de comunicar al equipo de desarrollo`,
      });
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleSubmit,
    resetForm,
    setValues,
  } = useFormik({
    onSubmit,
    initialValues: sugerenciaEmpaqueInitialValues,
    validationSchema: sugerenciaEmpaqueValidationSchema,
  });

  useEffect(() => {
    setValues({
      alias: sugerencia.alias,
      cultivo_id: sugerencia.cultivo_id,
      tipo_etiqueta_id: sugerencia.tipo_etiqueta_id,
      peso_envase_id: sugerencia.peso_envase_id,
      tipo_caja_id: sugerencia.tipo_caja_id,
      etiqueta_id: sugerencia.etiquetas_id,
      palet_id: sugerencia.palet_id ?? 0,
      bultos: sugerencia.bultos,
    });
  }, [sugerencia, setValues]);

  return (
    <SugerenciaForm
      values={values}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      errors={errors}
      touched={touched}
      handleSubmit={handleSubmit}
      isLoading={isSaving}
      onCancel={onCancel}
    />
  );
};
